import { authActionTypes } from './Auth.actionTypes';
import { IS_DEMO_MODE } from '@/utils/demoMode';

// Static profile for the public, no-login demo deployment — lets the demo
// site render as a fully "logged in" Admin without touching real Firebase auth.
const DEMO_PROFILE = {
  id: 'demo-user',
  email: 'ryan.mitchell@meridianlabs.com',
  name: 'Ryan Mitchell',
  firstName: 'Ryan',
  lastName: 'Mitchell',
  role: 'Admin',
  activeCompany: {
    companyId: 'demo-company',
    companyName: 'Meridian Labs',
    role: 'Admin',
  },
  companyList: [{ companyId: 'demo-company', companyName: 'Meridian Labs' }],
  onboardingData: { onboardingCompleted: true },
  subscription: {},
};

const initialState = IS_DEMO_MODE
  ? {
      authorized: true,
      loading: false,
      error: {},
      profile: DEMO_PROFILE,
      signUp: {
        pending: false,
        success: false,
        error: false,
        data: {},
      },
    }
  : {
      authorized: false,
      loading: false,
      error: {},
      profile: {
        subscription: {},
      },
      signUp: {
        pending: false,
        success: false,
        error: false,
        data: {},
      },
    };

export default function authReducer(state = initialState, action) {
  // Demo mode keeps the mock profile fixed — real Firebase auth sagas must
  // not be able to clobber it with an empty/unauthenticated state.
  if (IS_DEMO_MODE && action.type === authActionTypes.SET_STATE) {
    return state;
  }

  switch (action.type) {
    case authActionTypes.SET_STATE:
      return { ...state, ...action.payload };
    case authActionTypes.RESET_SIGNUP_STATE:
      return {
        ...state,
        signUp: {
          pending: false,
          success: false,
          error: false,
          data: {},
        },
      };
    // NEW: Handle subscription action
    case authActionTypes.PATCH_PROFILE:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        },
      };
    case authActionTypes.SET_SUBSCRIPTION_DATA:
      console.log(
        'Subscription: Auth reducer - SET_SUBSCRIPTION_DATA called with payload:',
        action.payload
      );
      return {
        ...state,
        profile: {
          ...state.profile,
          subscription: action.payload,
        },
      };
    default:
      return state;
  }
}
